import React, { Component } from "react";
import DeviceIdentifier from 'react-device-identifier';
import styled from 'styled-components';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons' 
import footerlogo from '../content/img/footerlogo.png';
import footerbg from '../content/img/footerbg.png';

library.add(faFacebookF, faTwitter, faInstagram); 

const FooterStyles = styled.footer`
  .footer {
    background-image: url(${footerbg});
    background-size: cover;
    background-repeat: no-repeat;
    color: #ffffff;
    background-position: center center;
  }
  .footer h3 {
    color: #12A845;
    font-size: 15px;
    font-weight: 500;
  }
  .footer .nav-link {
    padding: 0;
    line-height: 34px;
    font-size: 13px;
    color: white;
  }
  .footer .socialMedia .nav-link {
    width: 36px;
    height: 36px;
    background-color: rgba(255,255,255,0.2);
    border-radius: 50%;
    text-align: center;
    line-height: 40px;
    margin-right: 10px;
  }
  .footer .navbar-dark .navbar-text {
    color: rgba(255,255,255,1);
  }
`;
 
class Footer extends Component {
  render() {
    return (
        <>
            <FooterStyles as="footer">
                <section className="footer mt-5 pt-5">
                    <Container className="mt-4">
                        <Row>
                            <Col md={3}>
                                <h3>Hızlı Bağlantılar</h3>
                                <Nav className="flex-column">
                                    <Nav.Link href="/anlasmali-konut-projeleri">Anlaşmalı Konut Projeleri</Nav.Link>
                                    <Nav.Link href="/oranlarimiz">Oranlarımız</Nav.Link>
                                </Nav>
                            </Col>
                            <Col md={3}>
                                <h3>Merak Ettikleriniz</h3>
                                <Nav className="flex-column">
                                    <Nav.Link href="/bize-ulasin">Bize Ulaşın</Nav.Link>
                                    <Nav.Link href="/sss">Sıkça Sorulan Sorular</Nav.Link>
                                    <Nav.Link href="/mortgage/finansman-sureci">Finansman Süreci</Nav.Link>
                                    <Nav.Link href="/mortgage/sozlesmeler-ve-formlar">Sözleşmeler Formlar</Nav.Link>
                                </Nav>
                            </Col>
                            <Col md={3}>
                                <h3>Ev Alım Rehberi</h3>
                                <Nav className="flex-column">
                                    <Nav.Link href="/ev-alim-rehberi/hukuki-degerlendirme">Hukuki Değerlendirme</Nav.Link>
                                    <Nav.Link href="/ev-alim-rehberi/ekonomik-degerlendirme">Ekonomik Değerlendirme</Nav.Link>
                                    <Nav.Link href="/ev-alim-rehberi/tasiyici-sistem-ve-deprem-degerlendirme">Taşıyıcı Sistem Deprem Değerlendirme</Nav.Link>
                                    <Nav.Link href="/ev-alim-rehberi/emlak-ve-vergi-masraflari">Emlak ve Vergi Masrafları</Nav.Link>
                                </Nav>
                            </Col>
                            <Col md={3}>
                                <h3>Bizi Takip Edin</h3>
                                <p>Sosyal medya hesaplarımızı takip ederek bize ulaşabilir, güncel kampanyalardan haberdar olabilirsiniz.</p>
                                <Nav className="socialMedia" defaultActiveKey="/home" as="ul">
                                    <Nav.Item as="li">
                                        <Nav.Link target="_blank" href="https://www.facebook.com/TREmlakKatilim"><FontAwesomeIcon size="lg" icon={['fab', 'facebook-f']} /></Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li">
                                        <Nav.Link target="_blank" href="https://www.instagram.com/tremlakkatilim"><FontAwesomeIcon size="lg" icon={['fab', 'instagram']} /></Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li">
                                        <Nav.Link target="_blank" href="https://twitter.com/TREmlakKatilim"><FontAwesomeIcon size="lg" icon={['fab', 'twitter']} /></Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Navbar bg={'transparent'}  variant="dark" className="mb-3 mt-3">
                                    <DeviceIdentifier isDesktop={true}>
                                        <Navbar.Brand href="/"><Image src={footerlogo} width="206" height="47" alt="Emlak Katılım Logo" fluid /></Navbar.Brand>
                                        <Navbar.Text className="ml-auto justify-content-end">
                                            &copy; Türkiye Emlak Katılım Bankası A.Ş. {new Date().getFullYear()}
                                        </Navbar.Text>
                                    </DeviceIdentifier>
                                </Navbar>
                                    <DeviceIdentifier isMobile={true} isTablet={true}>
                                            <Row>
                                                <Col>
                                                    <a className="justify-content-center" href="/">
                                                        <Image src={footerlogo} width="206" height="47" alt="Emlak Katılım Logo" fluid />
                                                    </a>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <a className="CopyrightText justify-content-center" href="/">
                                                        &copy; Türkiye Emlak Katılım Bankası A.Ş. {new Date().getFullYear()}
                                                    </a>
                                                </Col>
                                            </Row>
                                    </DeviceIdentifier>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </FooterStyles>
        </>
    );
  }
}
 
export default Footer;